export const passwordRules = {
  minLength: 16,
  lowerCaseRegex: /[a-z]/,
  upperCaseRegex: /[A-Z]/,
  numberRegex: /[0-9]/,
  specialCharsRegex: /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
};